<div *ngIf="captchaSiteKey$ | async as captchaSiteKey">
  <div [ngClass]="cssClass">
    <re-captcha [siteKey]="captchaSiteKey" (resolved)="resolved($event)" class="captcha" />
  </div>
</div>
